(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/core/module/assets/javascripts/load.js') >= 0) return;  svs.modules.push('/components/core/module/assets/javascripts/load.js'); "use strict";

var _module = svs.core.module;
var helpers = svs.core.module.helpers;

_module.load = function (url, htmlFn, callback, urlArg, silentLoad, invalidCache) {
  if (urlArg) {
    return _module.filter.getAssets(url, urlArg, callback);
  }

  if (url.indexOf('/cl/') === 0) {
    url = "/_".concat(svs.core.config.data.svsconfig.tribe).concat(url);
  }

  if (url.indexOf('json=true') < 0) {
    url += '?json=true';
  } 


  url += '&v=2';

  if (invalidCache) {
    helpers.cache.clearCacheByKey(url);
  }

  var cacheData = helpers.cache.getFromCache(url);

  if (cacheData) {
    helpers.logger.debug("".concat(url, " found in module cache"));

    if (cacheData.init) {
      eval(cacheData.init);
    }

    if (callback) {
      callback(null, cacheData);
    }
  } else {
    helpers.logger.debug("".concat(url, " NOT found in module cache, load from server"));
    $.getJSON(url, function (data) {
      helpers.cache.storeInCache(url, data);
      helpers.loadStyles(data.styles);

      if (data.data) {
        $.extend(true, svs, data.data);
      }

      helpers.loadScripts(data.scripts, function () {
        if (!silentLoad && data.init) {
          eval(data.init);
        }

        if (callback) {
          callback(null, data);
        }
      });
    }).fail(callback);
  }

  return this;
};


_module.loadModuleComponent = function (component, callback) {
  var url = "/_".concat(svs.core.config.data.svsconfig.tribe, "/mcl/").concat(svs.core.data.module, "/").concat(component);
  $.getJSON(url, function (data) {
    helpers.loadStyles(data.styles);

    if (data.data) {
      $.extend(true, svs, data.data);
    }

    helpers.loadScripts(data.scripts, function () {
      return callback(null, data);
    });
  }).fail(callback);
};
 })(window);